import blogData from "../data/blog-posts.json";

export const BLOG_IMAGE_BASE = "/assets/images/blog/";

export const blogImageUrl = (fileName) =>
  !fileName
    ? ""
    : /^(https?:)?\/\//.test(fileName) || fileName.startsWith("/")
    ? fileName
    : BLOG_IMAGE_BASE + fileName;

export const getPosts = () => blogData.posts;
export const getPageSize = () => blogData.pageSize || 6;
export const getPostById = (id) =>
  blogData.posts.find((p) => String(p.id) === String(id));
export const blogPostLink = (post) =>
  `/single-blog?id=${encodeURIComponent(post.id)}`;
